import { QueueConfiguration, ContentType } from '../../services';
import { Admin } from '../../services/admin';
import { Moderator } from '../../services/moderator';

// TODO: Properly type this
export const Default_Cases = [
  {
    id: 'f8f80b44-1663-4c34-9c59-61b1e45aeb13',
    pk:
      'XBL:Moderation:PublicText:LFG\\00000000-0000-0000-0000-000066591171\\global(lfg)\\6b9761a2-f671-4992-a51b-7227bb981068',
    tenant: { tenantId: 'XBL' },
    title: { titleId: 'Moderation' },
    subject: {
      subjectId: 'LFG\\00000000-0000-0000-0000-000066591171\\global(lfg)\\6b9761a2-f671-4992-a51b-7227bb981068',
      subjectType: 'PublicText',
      subjectValue:
        '{"output":[{"type":"headerValue","value":{"header":"Description","value":"Ta mere a toi"}},{"type":"headerValue","value":{"header":"Tags","value":""}}]}',
      subjectHashes: { text: 'Ta mere a toi' },
      subjectLabels: ['Looking For Group'],
      subjectOwners: [{ userId: '2535420155172148', userType: 'Xuid', userTraits: [] }]
    },
    feedbacks: [],
    caseAssignedStartTime: '2021-10-14T16:27:19.161Z',
    caseCreationDateTime: '2021-10-13T20:18:11.3249437Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    outOfSla: false,
    caseActions: [],
    groundTruthCaseActions: false,
    status: 'Open',
    caseContext: {
      ContainerId:
        '{"scid":"00000000-0000-0000-0000-000066591171","templateName":"global(lfg)","name":"6b9761a2-f671-4992-a51b-7227bb981068"}',
      ItemId: '',
      ContainerType: 'LFG',
      IsTestRequest: true,
      InstanceId: ''
    },
    caseEvidence: {}
  },
  {
    id: '32f6310c-aac9-48df-98d4-ceca7e7a7c7b',
    pk:
      'XBL:Moderation:PublicText:LFG\\00000000-0000-0000-0000-000066591171\\global(lfg)\\6395405a-33a5-47e8-9d44-2147f3639492',
    tenant: { tenantId: 'XBL' },
    title: { titleId: 'Moderation' },
    subject: {
      subjectId: 'LFG\\00000000-0000-0000-0000-000066591171\\global(lfg)\\6395405a-33a5-47e8-9d44-2147f3639492',
      subjectType: 'PublicText',
      subjectValue:
        '{"output":[{"type":"headerValue","value":{"header":"Description","value":"Les quebequoi on 2 de qi et ne comprennent rien au jeux "}},{"type":"headerValue","value":{"header":"Tags","value":""}}]}',
      subjectHashes: {
        text: 'Les quebequoi on 2 de qi et ne comprennent rien au jeux '
      },
      subjectLabels: ['Looking For Group'],
      subjectOwners: [{ userId: '2535420155172148', userType: 'Xuid', userTraits: [] }]
    },
    feedbacks: [],
    caseAssignedStartTime: '2021-10-14T16:27:19.161Z',
    caseCreationDateTime: '2021-10-13T20:18:22.6975536Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    outOfSla: false,
    caseActions: [],
    groundTruthCaseActions: false,
    status: 'Open',
    caseContext: {
      ContainerId:
        '{"scid":"00000000-0000-0000-0000-000066591171","templateName":"global(lfg)","name":"6395405a-33a5-47e8-9d44-2147f3639492"}',
      ItemId: '',
      ContainerType: 'LFG',
      IsTestRequest: true,
      InstanceId: ''
    },
    caseEvidence: {}
  },
  {
    id: '90dc4bb4-3bed-4604-9c51-34cb8b51d72f',
    pk:
      'XBL:Moderation:PublicText:LFG\\b7b6df83-54f9-46ee-b1ec-95bbae5171db\\global(lfg)\\f44f4b12-e546-4d90-a374-dea04d0f0d47',
    tenant: { tenantId: 'XBL' },
    title: { titleId: 'Moderation' },
    subject: {
      subjectId: 'LFG\\b7b6df83-54f9-46ee-b1ec-95bbae5171db\\global(lfg)\\f44f4b12-e546-4d90-a374-dea04d0f0d47',
      subjectType: 'PublicText',
      subjectValue:
        '{"output":[{"type":"headerValue","value":{"header":"Description","value":"💕🤠HOWDY NIQQE4S IM HERE TO RIDE YOUR BIG CORN TELLL I SQUIRT HORSE NµT OUT OF MY BLOWHOLE AND EAT UP YOUR DOG BLOWHOLE SO JOIN NOW TEEE HEE💕"}},{"type":"headerValue","value":{"header":"Tags","value":"knowwhatyourdoing, LISTENTOTHEHOST, englishonly, actuallytalk, dontbeannoying, roleplay, joinparty, no5yearolds, DONTBETOXIC, gtaonline, FemaleGamersWelcome, girlswelcome, CharityWork"}}]}',
      subjectHashes: {
        text:
          '💕🤠HOWDY NIQQE4S IM HERE TO RIDE YOUR BIG CORN TELLL I SQUIRT HORSE NµT OUT OF MY BLOWHOLE AND EAT UP YOUR DOG BLOWHOLE SO JOIN NOW TEEE HEE💕'
      },
      subjectLabels: ['Looking For Group'],
      subjectOwners: [{ userId: '2535419824493784', userType: 'Xuid', userTraits: [] }]
    },
    feedbacks: [],
    caseAssignedStartTime: '2021-10-14T16:27:19.161Z',
    caseCreationDateTime: '2021-10-14T01:24:22.4343988Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    outOfSla: false,
    caseActions: [],
    groundTruthCaseActions: false,
    status: 'Open',
    caseContext: {
      ContainerId:
        '{"scid":"b7b6df83-54f9-46ee-b1ec-95bbae5171db","templateName":"global(lfg)","name":"f44f4b12-e546-4d90-a374-dea04d0f0d47"}',
      ItemId: '',
      ContainerType: 'LFG',
      IsTestRequest: true,
      InstanceId: ''
    },
    caseEvidence: {}
  },
  {
    id: 'ac751553-eb40-4af5-a1e1-1406b9927e37',
    pk:
      'XBL:Moderation:PublicText:LFG\\00000000-0000-0000-0000-000066591171\\global(lfg)\\cb19718c-f640-46e1-93cd-8c9b8056e1fc',
    tenant: { tenantId: 'XBL' },
    title: { titleId: 'Moderation' },
    subject: {
      subjectId: 'LFG\\00000000-0000-0000-0000-000066591171\\global(lfg)\\cb19718c-f640-46e1-93cd-8c9b8056e1fc',
      subjectType: 'PublicText',
      subjectValue:
        '{"output":[{"type":"headerValue","value":{"header":"Description","value":"Y\'a la place pour tous le monde chez moi j\'aime les gangbnnng"}},{"type":"headerValue","value":{"header":"Tags","value":""}}]}',
      subjectHashes: {
        text: "Y'a la place pour tous le monde chez moi j'aime les gangbnnng"
      },
      subjectLabels: ['Looking For Group'],
      subjectOwners: [{ userId: '2535455111702596', userType: 'Xuid', userTraits: [] }]
    },
    feedbacks: [],
    caseAssignedStartTime: '2021-10-14T16:27:19.161Z',
    caseCreationDateTime: '2021-10-14T11:45:56.8857696Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    outOfSla: false,
    caseActions: [],
    groundTruthCaseActions: false,
    status: 'Open',
    caseContext: {
      ContainerId:
        '{"scid":"00000000-0000-0000-0000-000066591171","templateName":"global(lfg)","name":"cb19718c-f640-46e1-93cd-8c9b8056e1fc"}',
      ItemId: '',
      ContainerType: 'LFG',
      IsTestRequest: true,
      InstanceId: ''
    },
    caseEvidence: {}
  },
  {
    id: 'b83c92d7-cd73-45de-8444-29af56b14a72',
    pk:
      'XBL:Moderation:PublicText:LFG\\00000000-0000-0000-0000-000066591171\\global(lfg)\\53bcdf14-cec0-4e7c-b005-6d0d7e5b3dca',
    tenant: { tenantId: 'XBL' },
    title: { titleId: 'Moderation' },
    subject: {
      subjectId: 'LFG\\00000000-0000-0000-0000-000066591171\\global(lfg)\\53bcdf14-cec0-4e7c-b005-6d0d7e5b3dca',
      subjectType: 'PublicText',
      subjectValue:
        '{"output":[{"type":"headerValue","value":{"header":"Description","value":"Je suis LGBT tres tres passif, je cherche beau mal pour soiree bien cremeuse. MP Discret"}},{"type":"headerValue","value":{"header":"Tags","value":""}}]}',
      subjectHashes: {
        text: 'Je suis LGBT tres tres passif, je cherche beau mal pour soiree bien cremeuse. MP Discret'
      },
      subjectLabels: ['Looking For Group'],
      subjectOwners: [{ userId: '2535455111702596', userType: 'Xuid', userTraits: [] }]
    },
    feedbacks: [],
    caseAssignedStartTime: '2021-10-14T16:27:19.161Z',
    caseCreationDateTime: '2021-10-14T12:08:55.8229771Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    outOfSla: false,
    caseActions: [],
    groundTruthCaseActions: false,
    status: 'Open',
    caseContext: {
      ContainerId:
        '{"scid":"00000000-0000-0000-0000-000066591171","templateName":"global(lfg)","name":"53bcdf14-cec0-4e7c-b005-6d0d7e5b3dca"}',
      ItemId: '',
      ContainerType: 'LFG',
      IsTestRequest: true,
      InstanceId: ''
    },
    caseEvidence: {}
  },
  {
    id: 'a033a3b0-ad34-4f6a-9bc4-8a6e802f9a01',
    pk:
      'XBL:Moderation:PublicText:LFG\\77290100-225e-4768-9373-98164430a9f8\\global(lfg)\\dfcce351-ee15-45e3-baec-580bce34832a',
    tenant: { tenantId: 'XBL' },
    title: { titleId: 'Moderation' },
    subject: {
      subjectId: 'LFG\\77290100-225e-4768-9373-98164430a9f8\\global(lfg)\\dfcce351-ee15-45e3-baec-580bce34832a',
      subjectType: 'PublicText',
      subjectValue:
        '{"output":[{"type":"headerValue","value":{"header":"Description","value":"Quick, Easy, and guaranteed LASO, Under 3hr and more achievement services, DM on Discord (LASO#9986) for more details"}},{"type":"headerValue","value":{"header":"Tags","value":""}}]}',
      subjectHashes: {
        text:
          'Quick, Easy, and guaranteed LASO, Under 3hr and more achievement services, DM on Discord (LASO#9986) for more details'
      },
      subjectLabels: ['Looking For Group'],
      subjectOwners: [{ userId: '2535418631386993', userType: 'Xuid', userTraits: [] }]
    },
    feedbacks: [],
    caseAssignedStartTime: '2021-10-14T16:27:19.161Z',
    caseCreationDateTime: '2021-10-09T11:09:32.588629Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    outOfSla: false,
    caseActions: [],
    groundTruthCaseActions: false,
    status: 'Open',
    caseContext: {
      ContainerId:
        '{"scid":"77290100-225e-4768-9373-98164430a9f8","templateName":"global(lfg)","name":"dfcce351-ee15-45e3-baec-580bce34832a"}',
      ItemId: '',
      ContainerType: 'LFG',
      IsTestRequest: true,
      InstanceId: ''
    },
    caseEvidence: {}
  },
  {
    id: '13020497-286a-4982-a05b-f9bd766ea5b6',
    pk:
      'XBL:Moderation:PublicText:LFG\\b7b6df83-54f9-46ee-b1ec-95bbae5171db\\global(lfg)\\f9acdbf6-4b69-472f-95fc-45779e03f08a',
    tenant: { tenantId: 'XBL' },
    title: { titleId: 'Moderation' },
    subject: {
      subjectId: 'LFG\\b7b6df83-54f9-46ee-b1ec-95bbae5171db\\global(lfg)\\f9acdbf6-4b69-472f-95fc-45779e03f08a',
      subjectType: 'PublicText',
      subjectValue:
        '{"output":[{"type":"headerValue","value":{"header":"Description","value":"☑️ Upo conta de GTA 5 ☑️ Dinheiro + Nvl a sua escolha ☑️ interessado? Chama no insta: @yuwkzs ☑️ status congelado pra nao dar ban ☑️ Dopns Mod Menu V1.57"}},{"type":"headerValue","value":{"header":"Tags","value":""}}]}',
      subjectHashes: {
        text:
          '☑️ Upo conta de GTA 5 ☑️ Dinheiro + Nvl a sua escolha ☑️ interessado? Chama no insta: @yuwkzs ☑️ status congelado pra nao dar ban ☑️ Dopns Mod Menu V1.57'
      },
      subjectLabels: ['Looking For Group'],
      subjectOwners: [{ userId: '2535458598060641', userType: 'Xuid', userTraits: [] }]
    },
    feedbacks: [],
    caseAssignedStartTime: '2021-10-14T16:27:19.161Z',
    caseCreationDateTime: '2021-10-10T20:01:46.7161964Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    outOfSla: false,
    caseActions: [],
    groundTruthCaseActions: false,
    status: 'Open',
    caseContext: {
      ContainerId:
        '{"scid":"b7b6df83-54f9-46ee-b1ec-95bbae5171db","templateName":"global(lfg)","name":"f9acdbf6-4b69-472f-95fc-45779e03f08a"}',
      ItemId: '',
      ContainerType: 'LFG',
      IsTestRequest: true,
      InstanceId: ''
    },
    caseEvidence: {}
  },
  {
    id: '2414c4a8-5ea3-431e-b5b8-a8424e9ebcd3',
    pk:
      'XBL:Moderation:PublicText:LFG\\d27d0100-8a4c-4cff-8605-d4c90f47d07e\\global(lfg)\\f7f80a7a-b31f-41f8-8831-080668721aa2',
    tenant: { tenantId: 'XBL' },
    title: { titleId: 'Moderation' },
    subject: {
      subjectId: 'LFG\\d27d0100-8a4c-4cff-8605-d4c90f47d07e\\global(lfg)\\f7f80a7a-b31f-41f8-8831-080668721aa2',
      subjectType: 'PublicText',
      subjectValue:
        '{"output":[{"type":"headerValue","value":{"header":"Description","value":"Try going outside and making friends you fortnite infants"}},{"type":"headerValue","value":{"header":"Tags","value":"BanAllMilsims"}}]}',
      subjectHashes: {
        text: 'Try going outside and making friends you fortnite infants'
      },
      subjectLabels: ['Looking For Group'],
      subjectOwners: [{ userId: '2533274974805662', userType: 'Xuid', userTraits: [] }]
    },
    feedbacks: [],
    caseAssignedStartTime: '2021-10-14T16:27:19.161Z',
    caseCreationDateTime: '2021-10-11T00:46:08.5942412Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    outOfSla: false,
    caseActions: [],
    groundTruthCaseActions: false,
    status: 'Open',
    caseContext: {
      ContainerId:
        '{"scid":"d27d0100-8a4c-4cff-8605-d4c90f47d07e","templateName":"global(lfg)","name":"f7f80a7a-b31f-41f8-8831-080668721aa2"}',
      ItemId: '',
      ContainerType: 'LFG',
      IsTestRequest: true,
      InstanceId: ''
    },
    caseEvidence: {}
  },
  {
    id: '6db31e90-e11b-4c59-be08-174bf306c3d1',
    pk:
      'XBL:Moderation:PublicText:Comments\\comments.xboxlive.com/gameclipsmetadata.xboxlive.com/users/xuid(2535457251914517)/scids/00000000-0000-0000-0000-000000000000/clips/44d00c06-b9c5-4de5-97c8-098e076a31b1\\08585677045000182148_198548874_2535433317900051',
    tenant: { tenantId: 'XBL' },
    title: { titleId: 'Moderation' },
    subject: {
      subjectId:
        'Comments\\comments.xboxlive.com/gameclipsmetadata.xboxlive.com/users/xuid(2535457251914517)/scids/00000000-0000-0000-0000-000000000000/clips/44d00c06-b9c5-4de5-97c8-098e076a31b1\\08585677045000182148_198548874_2535433317900051',
      subjectType: 'PublicText',
      subjectValue:
        '{"output":[{"type":"headerValue","value":{"header":"Text","value":"I can\'t find any good roblox posts wgac about this every time i refresh the posts i get this keep your gameplay to yourself - candice"}}]}',
      subjectHashes: {
        text:
          "I can't find any good roblox posts wgac about this every time i refresh the posts i get this keep your gameplay to yourself - candice"
      },
      subjectLabels: ['Comment'],
      subjectOwners: [{ userId: '2535433317900051', userType: 'Xuid', userTraits: [] }]
    },
    feedbacks: [],
    caseAssignedStartTime: '2021-10-14T16:27:19.161Z',
    caseCreationDateTime: '2021-10-11T01:09:39.8137973Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    outOfSla: false,
    caseActions: [],
    groundTruthCaseActions: false,
    status: 'Open',
    caseContext: {
      ContainerId:
        'comments.xboxlive.com/gameclipsmetadata.xboxlive.com/users/xuid(2535457251914517)/scids/00000000-0000-0000-0000-000000000000/clips/44d00c06-b9c5-4de5-97c8-098e076a31b1',
      ItemId: '08585677045000182148_198548874_2535433317900051',
      ContainerType: 'Comments',
      IsTestRequest: true,
      InstanceId: ''
    },
    caseEvidence: {}
  }
];

export const Moderators: Moderator[] = [
  {
    userId: 'Test UserID 1',
    userType: 'Moderator',
    canSetSourceWeight: false,
    canSetGroundTruthFeedback: true,
    canSetGroundTruthCaseActions: false
  }
];
export const Admins: Admin[] = [
  {
    userId: 'Test UserID 1',
    userType: 'Test User Type 1'
  }
];

export const FakeConfig: QueueConfiguration = {
  allowedAdmins: Admins, //add from user list
  allowedModerators: Moderators, // same -//-
  caseAssignedLifetimeInSeconds: 15,
  // caseCreationWindowLifetimeInSeconds: 14460,
  caseOpenLifetimeInSeconds: 14400,
  caseOpenLifetimeMaxInSeconds: 28800,
  caseOpenLifetimeWarningFactor: 0.9,
  contentType: ContentType.json,
  defaultCaseComparerAlgorithm: 'SourceWeight',
  defaultMaxAssignedCaseCount: 1,
  displayName: 'Location Unsafe',
  notAssignable: false,
  id: '1',
  // minimumModeratorFeedbackAgreementCount: 1,
  moderatorFeedbackCommentOptional: false,
  subjectType: 'LocationUnsafe',
  tenant: {
    displayName: 'MinecraftDev',
    tenantId: '488296E409C5C8B8',
    stackingConfigurationByTitleId: {
      Moderation: {
        enabled: true,
        lookbackWindowInDays: 180,
        maxPoints: 8
      },
      Investigation: {
        enabled: false,
        lookbackWindowInDays: 365,
        maxPoints: 8
      }
    }
  },
  title: {
    displayName: 'EarthDev',
    titleId: 'BC4A'
  },
  // subjectImage: {
  //   blurStrengthPixels: 10,
  //   isDefaultBlur: true,
  //   isDefaultFlipped: false,
  //   isDefaultGrayscale: false
  // },
  uxPreferences: {
    disableFiltersOnSelect: true,
    showCardTitleGradient: true,
    showReportContext: false,
    showCardZoomOption: true,
    decide: {
      showTimer: true,
      labelsPrompt: [
        {
          CSEAI:
            'Images that have been tagged with Child Sexual Exploitative & Abusive Imagery (CSEAI) or Terrorism will be escalated to Online Safety for review.'
        }
      ],
      labelsTop: ['Non-violating', 'Defer'],
      maxAllowedLabels: 1
    },
    feedback: {
      isDefaultCollapsed: true
    },
    subjectImage: {
      blurStrengthPixels: 10,
      isDefaultBlur: true,
      isDefaultFlipped: false,
      isDefaultGrayscale: false,
      isDefaultMirrored: false
    },
    subjectJson: {
      customCss: false
    }
  },
  revision: 1,
  showCaseContext: false,
  categorizedTraits: {
    Abuse: ['Domestic abuse', 'Animal cruelty'],
    Cheating: ['Offering/Providing/Promoting mods'],
    'Commerce & advertising': ['Advertising'],
    Harassment: [
      'Trolling',
      'Threats',
      'Targeted harassment',
      'Sexual harassment',
      'Retaliation',
      'IRL or non-digital harassment',
      'Hate speech'
    ],
    Impersonation: ['Unauthorized use of identity'],
    'Personal information': ['PII'],
    Phishing: ['Promoting phishing'],
    Piracy: ['Copyright infringement'],
    'Pre-release play': ['Unauthorized content distribution & methods'],
    'Sensitive content': [
      'Weapons/Safety',
      'Vulgar',
      'Violent extremist content',
      'Self-harm',
      'Violence/Gore',
      'Drugs & alcohol abuse',
      'Controversial'
    ],
    Sexual: ['Adult/Sexual', 'Racy/Suggestive', 'Revenge porn', 'Nudity', 'Non-CSEAI child nudity'],
    'Unclear self-identification': ['Self-identification'],
    Terrorism: ['Terrorism'],
    CSEAI: ['CSEAI'],
    'Non-violating': ['Non-violating'],
    Defer: ['Defer']
  },
  sourceTypeWeightMappings: {
    Moderator: 10
  }
};
